import React from 'react';

import { create_lead_with_oauth_path, create_user_path } from '../../../routes';
import { READER_URL } from '../../../src/env';
import LockedLeadCaptureForm from '../../shared/LockedLeadCaptureForm';
import MarketingLeadCaptureWithApple from '../../shared/LockedLeadCaptureForm/MarketingLeadCaptureWithApple';
import MarketingLeadCaptureWithGoogle from '../../shared/LockedLeadCaptureForm/MarketingLeadCaptureWithGoogle';
import marketingModalStyles from '../Layout/styles.module.scss';

const LeadCaptureModalBody = ({
  buttonText,
  disclosure,
  isGdprLead,
  leadType,
  offerLink,
  trackingProps,
}: {
  buttonText: string;
  disclosure?: string;
  isGdprLead?: boolean;
  leadType: string;
  offerLink: string;
  trackingProps?: { [key: string]: string };
}) => {
  const returningUri = `${READER_URL}/${offerLink}`;

  return (
    <div>
      <div className={marketingModalStyles.offerAction}>
        <div className="lead-form-capture">
          <LockedLeadCaptureForm
            buttonText={buttonText}
            redirectUri={offerLink}
            endpointUri={create_user_path()}
            isGdprLead={isGdprLead}
            leadType={leadType}
            emailPlaceholderText="your email address"
            trackingProps={{ ...trackingProps, name: 'subscribe' }}
          />
        </div>
        <p className="type mb1 mt1">- or -</p>
        <div className="flex flex-col items-center">
          <MarketingLeadCaptureWithGoogle
            eventName="createLeadWithGoogle"
            verificationUri={create_lead_with_oauth_path()}
            leadType={leadType}
            returningUri={returningUri}
          />
        </div>
        <div className="flex flex-col items-center mt-8">
          <MarketingLeadCaptureWithApple
            eventName="createLeadWithApple"
            verificationUri={create_lead_with_oauth_path()}
            leadType={leadType}
            returningUri={returningUri}
          />
        </div>
      </div>
      <div className={marketingModalStyles.disclosure}>{disclosure}</div>
    </div>
  );
};

export default LeadCaptureModalBody;
